import { useEffect } from "react";
import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import Navbar from "@xtribe/shared/components/lib/Navbar/Navbar";
import Layout from "@xtribe/shared/components/lib/Layout/Layout";

const ImpressumPage = () => {
  return (
    <div>
      <NextHead
        title={"Impressum — xTribe"}
        description={"Hier findest du unser Impressum"}
      />
      <Navbar />
      <Layout>
        <main className="mt-12 text-gray-700 max-w-6xl mx-auto px-2 md:px-4">
          <article className="page">
            <div className="page_wrapper u-cw">
              <div className="text-center">
                <h2 className="h2">Impressum</h2>
                <p className="page_last-edit fs4">February 2, 2019</p>
              </div>
              <div className="page_content text">
                <h4 className="h4 mb-3">xTribe</h4>
                <p>Erik Wilhelm</p>
                <p className="mb-3">
                  Fürther Str. 34
                  <br />
                  D-90574 Roßtal
                </p>
                <p className="mb-3">
                  <a href="mailto:erik@xtribe.app">erik@xtribe.app</a>
                </p>
                <p className="mb-3">
                  <a href="http://xtribe.app/">xtribe.app</a>
                </p>
                <p className="mb-3">
                  Geschäftsführer: Erik Wilhelm
                  <br />
                  <br />
                  Umsatzsteueridentifikationsnummer gemäß § 27a
                  Umsatzsteuergesetz: DE321220088
                </p>
                <p className="mb-3">&nbsp;</p>
                <p className="p4">
                  <b>Haftungsbeschränkungen für eigene Inhalte</b>
                </p>
                <p className="mb-3">
                  Alle Inhalte unseres Internetauftritts wurden mit Sorgfalt und
                  nach bestem Gewissen erstellt. Eine Gewähr für die Aktualität,
                  Vollständigkeit und Richtigkeit sämtlicher Seiten kann jedoch
                  nicht übernommen werden. Gemäß § 7 Abs. 1 TMG sind wir als
                  Dienstanbieter für eigene Inhalte auf diesen Seiten nach den
                  allgemeinen Gesetzen verantwortlich, nach den §§ 8 bis 10 TMG
                  jedoch nicht verpflichtet, die übermittelten oder
                  gespeicherten fremden Informationen zu überwachen. Eine
                  umgehende Entfernung dieser Inhalte erfolgt ab dem Zeitpunkt
                  der Kenntnis einer konkreten Rechtsverletzung und wir haften
                  nicht vor dem Zeitpunkt der Kenntnis-Erlangung.
                </p>
                <p className="mb-3">&nbsp;</p>
                <p className="p4">
                  <b>Haftungsbeschränkung für externe Inhalte</b>
                </p>
                <p className="mb-3">
                  Unsere Webseite enthält sog. „externe Links“ (Verknüpfungen zu
                  Webseiten Dritter), auf deren Inhalt wir keinen Einfluss haben
                  und für den wir aus diesem Grund keine Gewähr übernehmen. Für
                  die Inhalte und Richtigkeit der Informationen ist der
                  jeweilige Informationsanbieter der verlinkten Webseite
                  verantwortlich. Als die Verlinkung vorgenommen wurde, waren
                  für uns keine Rechtsverstöße erkennbar. Sollte uns eine
                  Rechtsverletzung bekannt werden, wird der jeweilige Link
                  umgehend von uns entfernt.
                </p>
                <p className="mb-3">&nbsp;</p>
                <p className="p4">
                  <b>Urheberrecht</b>
                </p>
                <p className="mb-3">
                  Die auf dieser Webseite veröffentlichten Inhalte und Werke
                  unterliegen dem deutschen Urheberrecht. Jede Art der
                  Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                  Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
                  vorherigen schriftlichen Zustimmung des jeweiligen Urhebers
                  bzw. Autors.
                </p>
                <p className="mb-3">&nbsp;</p>
                <p className="p4">
                  <b>Credits</b>
                </p>
                <p className="mb-3">
                  Apple, das Apple Logo und das iPhone sind eingetragene Marken
                  von Apple Inc., registriert in den USA und in anderen Ländern.
                  <br />
                  Quellen für Bilder &amp; Gerätenachbildungen:
                </p>
                <p className="mb-3">
                  <a href="https://unsplash.com/">unsplash.com</a>

                  <br />
                  <a href="http://graphicburger.com/">graphicburger.com</a>
                  <br />
                  <a href="http://www.freevector.com/">www.freevector.com</a>
                </p>
              </div>
            </div>
          </article>
        </main>
      </Layout>
    </div>
  );
};

export default ImpressumPage;
